import React from 'react';
import { observer } from 'mobx-react'
import MensagemStore from './store/MensagemStore';
import { IconButton } from '@mui/material';
import { HighlightOff } from '@mui/icons-material';
import './css/snackbar.css'

interface IPropsSnackBar {
}

class SnackBar extends React.Component {

    renderMensagens = (posicao: 'top' | 'bottom') => {
        return MensagemStore.mensagens
            .map((mensagem, index) => ({ mensagem, index }))
            .filter(({ mensagem }) => (mensagem.posicao || 'bottom') === posicao)
            .map(({ mensagem, index }) => {
                    const classeMensagem = 'mensagem-' + mensagem.variant;
                    let texto = mensagem?.conteudo;
                    let mensagemEhApiErroPadrao = typeof texto === 'string' && texto.includes('mensagem-api-erro-padrao');
                    let erro = { error: '', status: '', timestamp: '' };
                    if (texto && typeof texto !== 'string' && typeof texto === 'object') {
                        erro = {
                            error: (texto as any).error ?? '',
                            status: (texto as any).status ?? '',
                            timestamp: (texto as any).timestamp ?? ''
                        };
                        texto = erro.status + ": " + erro.error + " " + erro.timestamp;
                        mensagemEhApiErroPadrao = false;
                    }

                    return (
                        <div className={'mensagem ' + classeMensagem + (mensagemEhApiErroPadrao ? ' mensagem-com-api-erro' : '')} key={mensagem.variant + index}>
                            <span className='texto-mensagem' dangerouslySetInnerHTML={{ __html: texto }}></span>
                            <IconButton className={classeMensagem + ' botao-fechar-mensagem'} onClick={() => MensagemStore.limparMensagem(index)}>
                                <HighlightOff />
                            </IconButton>
                        </div>
                    );
            });
    }

    render() {
        return (
            <>
                <div className='mensagemSnackBar mensagemSnackBar-top'>
                    {this.renderMensagens('top')}
                </div>
                <div className='mensagemSnackBar mensagemSnackBar-bottom'>
                    {this.renderMensagens('bottom')}
                </div>
            </>
        );
    }
}

export default observer(SnackBar);
